export enum SharedLinkExpiryDuration {
    ThreeDays = "ThreeDays",
    SevenDays = "SevenDays",
    FourteenDays = "FourteenDays",
    ThirtyDays = "ThirtyDays"
}